module.exports = __webpack_public_path__ + "img/symbol_9.04b9bf8d.png";